// Design system colors
export const WHITE = '#FFFFFF';
export const BLACK = '#000000';
export const BLACK_300 = '#C4C4C4';
export const GRAY = '#F4F4F4';
export const NEUTRAL = '#FFFFFF';
export const DARK_BLUE = '#212F58';
export const MEDIUM_BLUE = '#26548A';
export const BLUE = '#598CBB';
export const LIGHT_BLUE = '#98D6F4';
export const DISABLED = '#D9D9D9';
export const EXTRA_STATE = '#D17617';
export const IN_PROGRESS = '#F8CF4A';
export const COMPLETED = '#5BBC64';
export const CANCELLED = '#C22B1F';

// Navigation & mobile tokens (NAV_HIERARCHY)
export const NAVY = '#17324E';
export const ACCENT = '#3A7CBF';
export const MUTED = '#8790A0';
export const HAIRLINE = '#ECEEF2';
export const SLATE = '#3A4A5E';

// Colors used before design system
export const GRAY1 = '#585858';
export const GRAY2 = '#C1C1C1';
export const GRAY3 = '#D9D9D9';
export const GREEN = '#A7CD78';

// Relatórios: aprovação/publicação. Espelho TS dos tokens de
// `components/Relatorios/shared/Aprovacao/_tokens.scss`, para cores passadas por prop.
export const DESSEM_APROVACAO_VERDE = '#1E7A4D';
export const DESSEM_APROVACAO_VERDE_ESCURO = '#14603B';
export const DESSEM_APROVACAO_AMARELO_TEXTO = '#8A6100';
export const DESSEM_APROVACAO_CINZA_EVENTO = '#8B96A1';

/**
 * Paleta default do ECharts 6 instalado (node_modules/echarts/lib/visual/tokens.js,
 * `color.theme`). Extraída como constante para que UI fora do canvas (ex.: bolinha
 * de cor do popover de rodadas do Flux Daily) referencie a MESMA cor que o gráfico
 * atribui a cada série — a cor é definida pelo ÍNDICE da série na ordem de
 * `Object.keys(data)`. Manter em sincronia ao atualizar o ECharts.
 */
export const CHART_SERIES_PALETTE = [
  '#5070dd',
  '#b6d634',
  '#505372',
  '#ff994d',
  '#0ca8df',
  '#ffd10a',
  '#fb628b',
  '#785db0',
  '#3fbe95',
];
